import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

function getApiOrigin(): string {
  const fromEnv = (process.env.REACT_APP_API_URL ?? '').trim().replace(/\/$/, '');
  if (fromEnv) return fromEnv;
  // Dev default: CRA runs on :3000, backend on :4000.
  return 'http://localhost:4000';
}

const ALLOWED_TYPES = new Set(['events', 'projects', 'classes', 'notices']);

const ShareRedirectPage: React.FC = () => {
  const { type, id } = useParams<{ type: string; id: string }>();

  useEffect(() => {
    if (!type || !id || !ALLOWED_TYPES.has(type)) {
      window.location.replace('/');
      return;
    }
    const target = `${getApiOrigin()}/share/${encodeURIComponent(type)}/${encodeURIComponent(id)}?siteOrigin=${encodeURIComponent(
      window.location.origin
    )}`;
    window.location.replace(target);
  }, [type, id]);

  return (
    <main className="min-vh-100 d-flex align-items-center justify-content-center p-4">
      <div className="text-center">
        <div className="spinner-border text-primary" role="status" aria-label="Loading" />
        <p className="mt-3 text-muted mb-0">Opening share preview…</p>
      </div>
    </main>
  );
};

export default ShareRedirectPage;

